// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__rX7Q5","activeroute":"Links_activeroute__1w-ch"};